export default __webpack_public_path__ + "static/media/sunflowerSeeds.3e6febdb.jpg";